import React from 'react';
import Dropdown from 'react-bootstrap/Dropdown';
import PropTypes from 'prop-types';
import Icon from '../Icon/Icon';
import './ActionsDropdown.scss';

// The forwardRef is important!!
// Dropdown needs access to the DOM node in order to position the Menu
// eslint-disable-next-line react/prop-types
const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
  // eslint-disable-next-line jsx-a11y/anchor-is-valid
  <a
    href=""
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
  >
    {children}
  </a>
));

const ActionsDropdown = ({
  children,
  onSelect,
}) => (
  <Dropdown onSelect={onSelect}>
    <Dropdown.Toggle as={CustomToggle} id="dropdown-custom-components">
      <Icon icon="ellipsis-v" color="#000" />
    </Dropdown.Toggle>

    <Dropdown.Menu>
      {children}
    </Dropdown.Menu>
  </Dropdown>
);

ActionsDropdown.propTypes = {
  children: PropTypes.node.isRequired,
  onSelect: PropTypes.func,
};

ActionsDropdown.defaultProps = {
  onSelect: undefined,
};

export default ActionsDropdown;
